import * as S from "../services";
import * as C from "../Components";
import { TC, T } from "../Constants";

type ImportRow = Parameters<T.API.Utils.Import.StandardActions>[0][number];

const import_standard_actions = () => new Promise<T.Submission<T.MaintenanceAction>[]>((resolve, reject) => {

    const mapper_format: Parameters<typeof C.Modal.renderExcelMapper<ImportRow>>[0] = {
        isFullScreen: true,
        allowIgnoring: true,
        title: TC.IMPORT_STANDARD_ACTIONS,
        columnFormat: {
            name: { key: "A", type: "string", required: true, label: TC.STANDARD_ACTION_IMPORT_COL_NAME},
            omniclasses: { key: "B", type: "array", required: true, label: TC.STANDARD_ACTION_IMPORT_COL_GAMMES },
            element: { key: "C", type: "string", required: true, label:TC.STANDARD_ACTION_IMPORT_COL_ELEMENT },
            priority: { key: "D", type: "number", required: true, label: TC.STANDARD_ACTION_IMPORT_COL_PRIORITY },
            cost: { key: "E", type: "number", label: TC.STANDARD_ACTION_IMPORT_COL_COST },
            unit: { key: "F", type: "string", label: TC.STANDARD_ACTION_IMPORT_COL_UNIT },
            frequency: { key: "G", type: "number", label: TC.STANDARD_ACTION_IMPORT_COL_FREQUENCY },
        },
    }

    C.Modal.renderExcelMapper(mapper_format).then((rows: ImportRow[]) => {
        if (!Array.isArray(rows) || rows.length === 0) resolve(null);
        else S.import_standard_actions(rows).then(actions => {
            if (actions.data.unknown_omniclasses.length > 0) C.Modal.renderAlert({
                delay: 15,
                type: "warning",
                title: TC.ACTION_IMPORT_UNKNOWN_GAMMES,
                message: actions.data.unknown_omniclasses.join(", "),
            });
            resolve(actions.data.submissions);
        }).catch(reject);
    });
});

export default import_standard_actions;